import breakpoints from '../utils/breakpoints'

const buildCustomBreakpoints = (custom: { [key: string]: string | number }) => {
  const base = breakpoints

  if (!custom || Object.keys(custom).length === 0) {
    return base
  }

  const addPoints = Object.keys(custom).reduce((acc, key) => {
    return {
      ...acc,
      [key]: {
        shortName: key,
        name: key,
        value: custom[key],
        em: Number(custom[key]) / 16,
      },
    }
  }, {})

  return addPoints
}

export default buildCustomBreakpoints
